// Global static constants for the Honor Mountain BGG application

// URLs
export const BGG_BASE_URL = 'https://boardgamegeek.com';
export const BGG_MARKETPLACE_URL = `${BGG_BASE_URL}/market/pricehistory/thing`;

// API Endpoints
export const BGG_API_BASE = 'https://api.boardgamegeek.com/xmlapi';
export const BGG_API_V2_BASE = 'https://api.boardgamegeek.com/xmlapi2';
export const BGG_SEARCH_API_PATH = '/.netlify/functions/bgg-search';
export const BGG_XML_API_PATH = '/.netlify/functions/fetch-bgg-xml';

// API Paths (relative)
export const API_PATH = {
    GEEKLISTS: '/api/geeklists',
    GEEKLIST_BY_ID: '/api/geeklists',
    LIST_ITEMS: '/api/listitems',
    COLLECTION: '/xmlapi2/collection',
    MARKET_PRICE_HISTORY: '/api/market/products/pricehistory'
};

// Application Configuration
export const DEFAULT_TIMEOUT = 10000; // 10 seconds
export const MAX_USERNAME_LENGTH = 50;
export const MAX_BULK_PRICE_LOOKUP = 100;
export const DEFAULT_PAGE_SIZE = 25;

// String Constants
export const APP_NAME = 'Honor Mountain';
export const APP_DESCRIPTION = 'Board Game Geek Trading Tools';

// Loading Messages
export const LOADING_MESSAGES = {
    DEFAULT: 'Loading...',
    ITEMS: 'Loading items',
    GEEKLIST_ITEMS: 'Loading geeklist items',
    DISTANCES: 'Loading distances',
    PRICES: 'Looking up prices',
    USERNAMES: 'Finding usernames',
    PRICE_HISTORY: 'Loading price history...',
    GAME_DETAILS: 'Loading game details...',
    SEARCHING: 'Searching'
};

// Error Messages
export const ERROR_MESSAGES = {
    GENERIC: 'An error occurred. Please try again.',
    FETCH_DATA: 'Error fetching data',
    FETCH_GEEKLIST: 'Error fetching geeklist data',
    FETCH_PRICE_HISTORY: 'Error fetching price history',
    FETCH_COMMENTS: 'Error fetching comments. Please try again.',
    FETCH_WISHLIST: 'Error retrieving wishlist data.',
    FETCH_ITEM_DATA: 'Error retrieving item data. Please try again.',
    FETCH_USER: 'Error loading user cache from localStorage',
    GEOCODING_FAILED: 'Geocoding failed for'
};

// Success Messages
export const SUCCESS_MESSAGES = {
    GEEKLIST_LOADED: 'Geeklist loaded successfully!'
};

// Status Values
export const STATUS = {
    TRUE: 'True',
    FALSE: 'False',
    NOT_APPLICABLE: 'N/A',
    UNKNOWN: '?',
    NOT_FOUND: 'Not Found',
    NOT_SPECIFIED: 'Not specified'
};

// Filter Types
export const FILTER_TYPES = {
    TEXT: 'text',
    NUMBER: 'agNumberColumnFilter',
    DATE: 'agDateColumnFilter',
    EQUALS: 'equals'
};

// Column Names
export const COLUMN_NAMES = {
    SELECT: 'Select',
    NAME: 'Name',
    PRICE: 'Price',
    LISTING_INFO: 'Listing Info',
    AVERAGE_PRICE: 'Average Price',
    EXTRAS: 'Extras',
    MATCHES: 'Matches',
    AVG_RATING: 'Avg. Rating',
    TYPE: 'Type',
    SELLER: 'Seller',
    LIST_DATE: 'List Date',
    EDIT_DATE: 'Edit Date',
    END_DATE: 'End Date',
    SOLD: 'Sold',
    EXPANSION: 'Expansion',
    LOCATION: 'Location'
};

// Price Types - Enum for listing price types
export const PRICE_TYPES = {
    // Single types
    STARTING_BID: 'SB',
    BUY_IT_NOW: 'BIN',
    FIXED_PRICE: 'FP',
    SOFT_RESERVE: 'SR',
    
    // Combined types
    STARTING_BID_WITH_BIN: 'SB+BIN',
    SOFT_RESERVE_WITH_BIN: 'SR+BIN',
    FIXED_PRICE_WITH_BIN: 'FP+BIN',
    
    // Other
    STARTING_BID_FULL: 'Starting Bid',
    UNSTRUCTURED: 'Unstructured',
    NOT_APPLICABLE: 'N/A'
};

// Helper function to check if a price type includes BIN
export const hasBIN = (priceType) => {
    return priceType && priceType.includes('+BIN');
};

// Toast Options
export const TOAST_OPTIONS = {
    AUTO_CLOSE_TRUE: { autoClose: true },
    AUTO_CLOSE_FALSE: { autoClose: false }
};

// BGG User Status Messages
export const USER_NOT_FOUND = 'User not found on Board Game Geek';
export const USER_PRIVATE = 'This user has set their collection to private';

// Geeklist Related Constants
export const GEEKLIST_TYPE_TRADE = 'trade';
export const GEEKLIST_TYPE_SELL = 'sell';
export const GEEKLIST_TYPE_WANT = 'want';

// Component Limit Constants
export const MAX_ITEMS_PER_PAGE = 50;
export const MAX_SEARCH_RESULTS = 100;

// Currency Related
export const DEFAULT_CURRENCY = 'USD';
export const CURRENCY_SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£'
};

// Cache Configuration
export const CACHE_CONFIG = {
    BGG_USERS_KEY: 'bgg_users_cache',
    DURATION_24_HOURS: 24 * 60 * 60 * 1000
};

// Grid Column IDs
export const COLUMN_IDS = {
    DEAL_SCORE: 'dealScore',
    MATCHES: 'matches',
    EXTRAS_IDS: 'extrasIds',
    STATS_AVERAGE: 'stats.average',
    POST_DATE: 'postdate',
    EDIT_DATE: 'editdate',
    END_DATE: 'endDate',
    LOCATION: 'location'
};
